import { Route, Routes } from "react-router-dom/dist";
import Navbar from "../src/components/Navbar";
import Cart from "../src/pages/Cart";
import Home from "../src/pages/Home"
import { ToastContainer } from "react-toastify";


const App = () => {
  return (

    // <ToastContainer>
       <div>
      <div>
          <Navbar/>
      </div>
       
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route  path="/cart" element={<Cart/>}/>
          </Routes>

    </div>
          
    // </ToastContainer>
   
 
 
  )
  
};

export default App;
